(function () {
  function getItems(tile) {
    return Array.from(tile.querySelectorAll('.ecbn-selection-item'));
  }

  function hideAfterNine(tile) {
    if (tile.classList.contains('is-expanded')) return;

    const items = getItems(tile);

    items.forEach(function (item, index) {
      if (index >= 9) {
        item.classList.add('is-visumo-hidden');
      } else {
        item.classList.remove('is-visumo-hidden');
      }
    });
  }

  function showAll(tile) {
    tile.classList.add('is-expanded');

    getItems(tile).forEach(function (item) {
      item.classList.remove('is-visumo-hidden');
      item.style.display = '';
    });
  }

  function initVisumoTile(tile) {
    if (!tile) return;

    hideAfterNine(tile);

    const observer = new MutationObserver(function () {
      if (tile.classList.contains('is-expanded')) {
        showAll(tile);
      } else {
        hideAfterNine(tile);
      }
    });

    observer.observe(tile, {
      childList: true,
      subtree: true
    });
  }

  function initAll() {
    document.querySelectorAll('.cj-lp .vsm-tile').forEach(initVisumoTile);
  }

  document.addEventListener('DOMContentLoaded', initAll);

  window.addEventListener('load', function () {
    setTimeout(initAll, 500);
    setTimeout(initAll, 1500);
  });

  document.addEventListener(
    'click',
    function (event) {
      const moreButton = event.target.closest('.cj-lp .vsm-tile .ecbn-selection-more-btn');

      if (!moreButton) return;

      const tile = moreButton.closest('.vsm-tile');

      if (!tile) return;

      showAll(tile);

      /*
        Moreクリック後、visumoが追加DOMを生成するまで少し待って再適用
      */
      setTimeout(function () {
        showAll(tile);
      }, 300);

      setTimeout(function () {
        showAll(tile);
      }, 1000);
    },
    true
  );
})();

(function () {
  function getCjRem(lp) {
    const value = getComputedStyle(lp).getPropertyValue("--cj-rem");
    const parsed = parseFloat(value);
    return Number.isFinite(parsed) ? parsed : 16;
  }

  function initFloatButton(lp) {
    const achievement = lp.querySelector(".bl-achievement");
    const floatButton = lp.querySelector(".el-btn.--more.--float");

    if (!achievement || !floatButton) return;

    const fourRem = getCjRem(lp) * 4;

    const observer = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];

        if (entry.isIntersecting) {
          floatButton.classList.add("is-show");
          return;
        }

        if (entry.boundingClientRect.top > entry.rootBounds.bottom) {
          floatButton.classList.remove("is-show");
          return;
        }

        floatButton.classList.add("is-show");
      },
      {
        root: null,
        rootMargin: `0px 0px -${fourRem}px 0px`,
        threshold: 0,
      }
    );

    observer.observe(achievement);
  }

  function init() {
    document.querySelectorAll(".cj-lp").forEach(initFloatButton);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();

(function () {
  function initSmoothScroll() {
    document.addEventListener("click", function (event) {
      const link = event.target.closest('.cj-lp a[href^="#"]');

      if (!link) return;

      const href = link.getAttribute("href");

      if (!href || href === "#") return;

      const target = document.querySelector(href);

      if (!target) return;

      event.preventDefault();

      target.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });

      history.pushState(null, "", href);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initSmoothScroll);
  } else {
    initSmoothScroll();
  }
})();
